import { FC, type ReactNode, Ref } from "react"

import { cn } from "../utilities/tailwind"

type Props = {
	profile: {
		avatarFilePath: string
		firstName: string
		lastName: string
		gamification?: { currentLevel: { tier: number } | null } | null
	}
	size?: number
	backgroundColor?: string
	className?: string
	children?: ReactNode
	ref?: Ref<HTMLDivElement>
}
const CommunityProfileAvatar: FC<Props> = ({
	profile,
	size = 42,
	backgroundColor = "#f8f6f3",
	className,
	children,
	ref,
}) => (
	<div
		ref={ref}
		className={cn(
			"relative flex shrink-0 grow-0 items-center justify-center overflow-hidden rounded-full",
			className,
		)}
		style={{ width: size, height: size, backgroundColor }}
	>
		{profile.gamification?.currentLevel != null && size >= 82 && (
			<div className="absolute bottom-1 left-1/2 min-w-6 -translate-x-1/2 rounded-xl bg-green-300 px-2 py-1 text-center leading-4 text-white">
				{profile.gamification.currentLevel.tier}
			</div>
		)}
		<img alt="Profile avatar" src={profile.avatarFilePath} className="size-full object-cover" />
		{children}
	</div>
)

export default CommunityProfileAvatar
